import { render, staticRenderFns } from "./DashComp.vue?vue&type=template&id=a25da1b8&scoped=true&"
import script from "./DashComp.vue?vue&type=script&lang=js&"
export * from "./DashComp.vue?vue&type=script&lang=js&"
import style0 from "./DashComp.vue?vue&type=style&index=0&id=a25da1b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25da1b8",
  null
  
)

export default component.exports